import useSWRMutation from "swr/mutation";
import { Network } from "@/utils/network";
import { zodUnsafeValidate } from "@/utils/zod";
import { CustomModal } from "@/deprecated/custom-modal/custom-modal";
import { Calc } from "../types";
import { useCalculator } from "./useCalculator";

export const useCalculatorPaymentSubmit = (
  paymentMethod?: Calc.Payment.Method,
) => {
  const api = useCalculator((state) => state.api);
  const getRequestData = useCalculator((state) => state.getRequestData);

  return useSWRMutation(
    api.paymentSubmit,
    async () => {
      const { data } = await Network.post<
        Calc.Api.PaymentSubmitResponse,
        Calc.Api.PaymentSubmitRequest
      >(api.paymentSubmit, {
        ...getRequestData(),
        paymentMethod: paymentMethod?.id,
        paymentMethodType: paymentMethod?.type,
      });

      return zodUnsafeValidate(Calc.Api.PaymentSubmitResponseSchema, data);
    },
    {
      onSuccess: (data) => {
        switch (data.redirectType) {
          case "url":
            document.location.href = data.redirectUrl;
            break;
          case "modal":
            CustomModal.create(data.redirectModal).open();
            break;
        }
      },
    },
  );
};
